import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTags, loadingTags } from './redux/selectors';
import { delete_tag, get_tags } from './redux/reducers';
import LoadingDataUi from '@app/components/loading';
import TagTable from './components/tag-table';
import { FormsModal } from '@app/globalstyles/asgard';
import AddTag from './components/addTag';
import { Link } from 'react-router-dom';
import Modal from './blocks/modal';
import AttachMeal from './blocks/attach-meal';

const { Parser } = require('json2csv');
const fileDownload = require('js-file-download');

const fields = ['Category', 'Tag Name', 'Tag Id', 'Description'];
const tagsParser = new Parser({ fields });

const MealTags = () => {
  const tags = useSelector(getTags);
  const loading = useSelector(loadingTags);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [content, setContent] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [showAttachModal, setShowAttachModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [tagSearch, setTagSearch] = useState('');

  useEffect(() => {
    dispatch(get_tags());
  }, [dispatch]);

  function StopBubbling(e) {
    e.stopPropagation();
  }

  const handleDelete = (doc) => {
    dispatch(delete_tag(doc));
  };

  const handleEdit = (doc) => {
    setContent(doc);
    setIsEdit(!isEdit);
    setTimeout(() => {
      setShow(!show);
    }, 400);
  };

  const handleAttach = (tag) => {
    setSelectedTag(tag);
    setShowAttachModal(true);
  };

  const closeAttachModal = () => {
    setShowAttachModal(false);
    setSelectedTag(null);
  };

  const exportTags = () => {
    let temp = [];

    tags.forEach((t) => {
      let obj = {
        Category: t.category,
        'Tag Name': t.tags.map((t) => t.name).join(', '),
        'Tag Id': t.tags.map((t) => t._id).join(', '),
        Description: t.tags.map((t) => t.description).join(' ')
      };
      temp.push(obj);
    });
    const csv = tagsParser.parse(temp);
    fileDownload(csv, 'Tags.csv');
  };

  const filteredTags = tags
    .map((group) => ({
      ...group,
      tags: (group?.tags || []).filter((tag) =>
        (tag?.name || '').toLowerCase().includes(tagSearch.toLowerCase().trim())
      )
    }))
    .filter((group) => group.tags.length > 0);

  return (
    <div>
      <Modal open={showAttachModal} onOpenChange={setShowAttachModal}>
        <AttachMeal tag={selectedTag} onClose={closeAttachModal} />
      </Modal>
      {show && (
        <FormsModal show={show} onClick={() => setShow(!show)}>
          <div onClick={StopBubbling}>
            <AddTag
              onClose={() => {
                setShow(!show);
                setContent(null);
                setIsEdit(false);
              }}
              content={content}
              isEdit={isEdit}
            />
          </div>
        </FormsModal>
      )}
      <div className="flex justify-between items-center p-6">
        <p className="text-[#222222] text-[24px] font-[600]"></p>
        <div className="flex gap-2 items-center">
          <button
            className="bg-[#549a9a] text-white text-[16px] font-[600] p-3 rounded-md"
            onClick={exportTags}
          >
            Export
          </button>
          <button
            onClick={() => {
              setShow(!show);
              setContent(null);
              setIsEdit(false);
            }}
            className="bg-[#549a9a] text-white rounded-[9px] p-4 text-[16px] font-[600] cursor-pointer"
          >
            Add a tag
          </button>
          <Link
            to={'/meal/tags/bulk'}
            className="bg-[#549a9a] text-white rounded-[9px] p-4 text-[16px] font-[600] cursor-pointer"
          >
            Edit Bulk
          </Link>
        </div>
      </div>

      <div className="p-6 mt-6">
        <div className="mb-4">
          <input
            type="text"
            value={tagSearch}
            onChange={(e) => setTagSearch(e.target.value)}
            placeholder="Search by tag name"
            className="w-full md:w-[360px] border border-[#E5E7EB] rounded-md px-4 py-2 text-sm outline-none focus:border-[#549a9a]"
          />
        </div>
        {loading ? (
          <LoadingDataUi />
        ) : (
          <TagTable
            tags={filteredTags}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleAttach={handleAttach}
          />
        )}
      </div>
    </div>
  );
};

export default MealTags;
